<template>
  <div class="d-flex">
    <div>
      <v-icon :color="color">{{ iconName }}</v-icon>
      <div class="caption">{{ caption }}</div>
    </div>
    <div class="ml-2 display-1 text--secondary" v-text="value" />
  </div>
</template>

<script>
import { ref } from 'vue'
import { userData } from '@/store/UserSession'
import { feature, icon } from '@/use/Constants'
import { host } from '@/services/HostAPI'
export default {
  name: 'TaskDashboardWidgetItem',
  props: {
    color: {
      type: String,
      default: 'green'
    },
    iconName: {
      type: String,
      required: true
    },
    caption: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default: 0
    }
  },
  setup() {
    const summary = ref()

    const loadData = async () => {
      const rq = {
        UserId: userData.value.UserId,
        TaskDate: new Date().toISOString().substr(0, 10)
      }
      const rs = await host.scheduledTask.getSummary(rq)
      summary.value = rs
    }

    loadData()

    return { summary, feature, icon }
  }
}
</script>
